import { PerformSearchFailedAction, SearchActionTypes } from './ActionTypes';

export function performSearchFailed(error: string): PerformSearchFailedAction {
  return {
    type: SearchActionTypes.SEARCH_FAILED,
    error,
  };
}
